import React from "react";
import { Pill } from "../ui";

export const DECISIONS = {
  approve: { label: "Recommend approval", tone: "green" },
  review: { label: "Needs human review", tone: "sky" },
  further_info: { label: "Request more info", tone: "amber" },
  decline: { label: "Likely decline", tone: "red" },
};
const VERDICTS = {
  within: ["Within range", "green"], below: ["Below average", "green"], above: ["Above range", "amber"],
  well_above: ["Well above range", "red"], no_benchmark: ["No price history", "neutral"], no_amount: ["No amount", "neutral"],
};
const AGREE = { agree: ["Matches human", "green"], partial: ["Partly matches", "sky"], disagree: ["Differs from human", "red"] };
const OUTCOMES = { approved: "Approved", declined: "Declined", info: "More info requested", pending: "Awaiting decision", unknown: "Unknown" };
export const SCORE_LABELS = {
  pricing: "Pricing vs history", scope: "Repair scope", evidence: "Evidence", eligibility: "Warranty eligibility", extraction: "Repair order reading",
};

export const outcomeLabel = (o) => OUTCOMES[o] || o || "—";
export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString("en-AU", { timeZone: "Australia/Brisbane", dateStyle: "medium", timeStyle: "short" }) : "—");

export function DecisionPill({ decision, testId }) {
  const d = DECISIONS[decision];
  return d ? <Pill tone={d.tone} testId={testId}>{d.label}</Pill> : <Pill testId={testId}>—</Pill>;
}

export function VerdictPill({ verdict, diff }) {
  const [label, tone] = VERDICTS[verdict] || [verdict, "neutral"];
  return <Pill tone={tone}>{label}{diff !== null && diff !== undefined ? ` · ${diff > 0 ? "+" : ""}${diff}%` : ""}</Pill>;
}

export function AgreementPill({ value, testId }) {
  if (!value) return null;
  const [label, tone] = AGREE[value];
  return <Pill tone={tone} testId={testId}>{label}</Pill>;
}

const ringColor = (v) => (v >= 90 ? "#73bf44" : v >= 61 ? "#38bdf8" : "#f59e0b");

export function ConfidenceRing({ value, size = 64, testId }) {
  const r = size / 2 - 5;
  const c = 2 * Math.PI * r;
  const v = value ?? 0;
  return (
    <div className="relative shrink-0" style={{ width: size, height: size }} data-testid={testId}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} stroke="rgba(255,255,255,0.07)" strokeWidth="5" fill="none" />
        <circle cx={size / 2} cy={size / 2} r={r} stroke={ringColor(v)} strokeWidth="5" fill="none" strokeLinecap="round"
          strokeDasharray={c} strokeDashoffset={c * (1 - v / 100)} style={{ transition: "stroke-dashoffset 600ms ease" }} />
      </svg>
      <span className="absolute inset-0 flex items-center justify-center font-heading font-bold text-white tabular-nums" style={{ fontSize: size / 4 }}>{value ?? "—"}</span>
    </div>
  );
}

export function ScoreBars({ scores, weights }) {
  return (
    <div className="space-y-2.5" data-testid="wi-score-bars">
      {Object.keys(SCORE_LABELS).map((k) => (
        <div key={k}>
          <div className="flex justify-between text-[0.7rem] text-neutral-400 mb-1">
            <span>{SCORE_LABELS[k]} <span className="text-neutral-600">· weight {weights?.[k] ?? 0}%</span></span>
            <span className="tabular-nums text-neutral-200" data-testid={`wi-score-${k}`}>{scores?.[k] ?? "—"}</span>
          </div>
          <div className="h-1.5 rounded-full bg-white/[0.05] overflow-hidden">
            <div className="h-full rounded-full transition-[width] duration-700" style={{ width: `${scores?.[k] ?? 0}%`, background: ringColor(scores?.[k] ?? 0) }} />
          </div>
        </div>
      ))}
    </div>
  );
}
